import React from "react"
import { NavLink } from "react-router-dom"
import { TextLink, View, Text, Grid, Col } from "react-ame-components"
import Showcase from "./components/Showcase"
import { BoxContainer } from "./components/BoxContainer"

export default class Home extends React.Component {
  contentComponents = [
    { name: "Ads", checked: true },
    { name: "Animator", checked: false },
    { name: "ChartBar", checked: true },
    { name: "ChartLine", checked: true },
    { name: "ChartPie", checked: true },
    { name: "Grid", checked: true },
    { name: "Image", checked: false },
    { name: "QRCode", checked: true },
    { name: "Touchable", checked: true },
    { name: "Video", checked: false },
  ]
  componentList = [
    { name: "Accordion", checked: false },
    { name: "Bullet", checked: false },
    { name: "Button", checked: true },
    { name: "CardNavigation", checked: false },
    { name: "Carousel", checked: false },
    { name: "Checkbox", checked: true },
    { name: "Chip", checked: true },
    { name: "CurrencyInput", checked: true },
    { name: "DatePicker", checked: false },
    { name: "FormSelect", checked: false },
    { name: "Hint", checked: false },
    { name: "Icon", checked: false },
    { name: "Input", checked: false },
    { name: "Label", checked: false },
    { name: "List", checked: false },
    { name: "Map", checked: false },
    { name: "Modal", checked: false },
    { name: "Pagination", checked: false },
    { name: "Radio", checked: true },
    { name: "SegmentedControl", checked: true },
    { name: "Select", checked: false },
    { name: "SellerPerfil", checked: false },
    { name: "Slider", checked: false },
    { name: "Status", checked: false },
    { name: "Tests", checked: false },
    { name: "Text", checked: false },
    { name: "TextLink", checked: false },
    { name: "Toggle", checked: false },
    { name: "Tooltip", checked: true },
    { name: "ValueInput", checked: true },
    { name: "View", checked: true },
    { name: "DataTable", checked: false },
    { name: "InfiniteScroll", checked: false },
  ]

  render() {
    return (
      <Showcase
        skipBackButton={true}
        title="Biblioteca de componentes"
        description="Utilize os botões abaixo para navegar pelos exemplos, atualmente os componentes estão divididos em 3 tipos.">
        <Grid>
          <Col columnSize={{ sm: 12, lg: 4 }}>
            <BoxContainer>
              <View
                direction="column"
                marginBottom="small">
                <Text fontWeight="bold">Componentes de organização.</Text>
                <Text>Apenas organização ou apresentação de conteúdo.</Text>
                <Text>Estes componentes não possuem nenhum visual.</Text>
              </View>
              <View
                direction="column"
                align="start">
                {this.contentComponents.map(x => {
                  let name = `${x.name}`
                  return (
                    <NavLink
                      key={x.name}
                      style={{ padding: 1, display: "inline-block" }}
                      to={`/${x.name.toLocaleLowerCase()}`}>
                      <TextLink onClick={() => {}}>{name}</TextLink>
                    </NavLink>
                  )
                })}
              </View>
            </BoxContainer>
          </Col>
          <Col columnSize={{ sm: 12, lg: 4 }}>
            <BoxContainer>
              <View
                direction="column"
                marginBottom="small">
                <Text fontWeight="bold">Componentes concluídos.</Text>
                <Text>
                  Estes componentes já foram revisados e estão 100% prontos para
                  uso.
                </Text>
              </View>
              <View
                direction="column"
                justify="start">
                {this.componentList
                  .filter(x => x.checked)
                  .map(x => {
                    let name = `${x.name}`
                    return (
                      <NavLink
                        key={x.name}
                        style={{
                          padding: 1,
                          display: "block",
                          width: "100%",
                        }}
                        to={`/${x.name.toLocaleLowerCase()}`}>
                        <TextLink onClick={() => {}}>{name}</TextLink>
                      </NavLink>
                    )
                  })}
              </View>
            </BoxContainer>
          </Col>
          <Col columnSize={{ sm: 12, lg: 4 }}>
            <BoxContainer>
              <View
                direction="column"
                marginBottom="small">
                <Text fontWeight="bold">Componentes sob revisão.</Text>
                <Text>
                  Estes componentes passarão por reorganização, podendo deixarem
                  de existir ou serem substituídos por outros.
                </Text>
              </View>
              <View
                direction="column"
                justify="start">
                {this.componentList
                  .filter(x => !x.checked)
                  .map(x => {
                    let name = `${x.name}`
                    return (
                      <NavLink
                        key={x.name}
                        style={{ padding: 1, display: "inline-block" }}
                        to={`/${x.name.toLocaleLowerCase()}`}>
                        <TextLink onClick={() => {}}>{name}</TextLink>
                      </NavLink>
                    )
                  })}
              </View>
            </BoxContainer>
          </Col>
        </Grid>
      </Showcase>
    )
  }
}
